import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {libraryPageText as libraryPageText_en} from "../libs/en/texts-library-page-lib";
import {libraryPageText as libraryPageText_en_ca} from "../libs/en-ca/texts-library-page-lib";
import {libraryPageText as libraryPageText_de} from "../libs/de/texts-library-page-lib";
import {libraryPageText as libraryPageText_de_ch} from "../libs/de-ch/texts-library-page-lib";
import {libraryPageText as libraryPageText_fr} from "../libs/fr/texts-library-page-lib";
import {libraryPageText as libraryPageText_fr_fr} from "../libs/fr-fr/texts-library-page-lib";
import {libraryPageText as libraryPageText_fr_ca} from "../libs/fr-ca/texts-library-page-lib";
import {libraryPageText as libraryPageText_nl} from "../libs/nl/texts-library-page-lib";
import {libraryPageText as libraryPageText_it} from "../libs/it/texts-library-page-lib";
import {libraryPageText as libraryPageText_it_ch} from "../libs/it-ch/texts-library-page-lib";
import {libraryPageText as libraryPageText_cz} from "../libs/cz/texts-library-page-lib";
import {libraryPageText as libraryPageText_fi} from "../libs/fi/texts-library-page-lib";
import {libraryPageText as libraryPageText_pl} from "../libs/pl/texts-library-page-lib";
import {libraryPageText as libraryPageText_se} from "../libs/se/texts-library-page-lib";
import {libraryPageText as libraryPageText_no} from "../libs/no/texts-library-page-lib";
import {libraryPageText as libraryPageText_dk} from "../libs/dk/texts-library-page-lib";
import {libraryPageText as libraryPageText_es} from "../libs/es/texts-library-page-lib";
import {libraryPageText as libraryPageText_pt} from "../libs/pt/texts-library-page-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {getLibertyStepImagePath} from '../libs/liberty-step-images';
import greenCheckIcon from '../assets/images/green-check-ic.svg';
import redCloseIcon from '../assets/images/red-close.svg';
import fileIcon from '../assets/images/file-ic.svg';
import libertyPlayBtn from '../assets/images/liberty-play-btn.svg';
import libertyDownloadArrow from '../assets/images/liberty-download-arrow.svg';
import androidIcon from '../assets/images/android-ic-teal.svg';
import appleIcon from '../assets/images/apple-ic.svg';

const LIBERTY_CC_LANG = {
    DE: 'de',
    'DE-CH': 'de',
    FR: 'fr',
    'FR-FR': 'fr',
    'FR-CA': 'fr',
    NL: 'nl',
    IT: 'it',
    'IT-CH': 'it',
    CZ: 'cs',
    FI: 'fi',
    PL: 'pl',
    SE: 'sv',
    NO: 'no',
    DK: 'da',
    ES: 'es',
    PT: 'pt',
};

export class Liberty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            libraryPageText: libraryPageText_en,
            prefix: '',
            activeStep: 1,
            imageLoaded: true,
            progressKey: 0,
            isVideoOpen: false,
            selectedVideo: null,
        };
        this.stepInterval = 4500; // 4.5 seconds per step
        this.autoPlayTimer = null;
        this.handleStepClick = this.handleStepClick.bind(this);
        if (this.state.language === "DE") {
            this.state.libraryPageText = libraryPageText_de;
            this.state.prefix = '/de';
        }
        if (this.state.language === "DE-CH") {
            this.state.libraryPageText = libraryPageText_de_ch;
            this.state.prefix = '/de-ch';
        }
        if (this.state.language === "EN-CA") {
            this.state.libraryPageText = libraryPageText_en_ca;
            this.state.prefix = '/en-ca';
        }
        if (this.state.language === "FR-FR") {
            this.state.libraryPageText = libraryPageText_fr_fr;
            this.state.prefix = '/fr';
        }
        if (this.state.language === "FR") {
            this.state.libraryPageText = libraryPageText_fr;
            this.state.prefix = '/fr-ch';
        }
        if (this.state.language === "FR-CA") {
            this.state.libraryPageText = libraryPageText_fr_ca;
            this.state.prefix = '/fr-ca';
        }
        if (this.state.language === "NL") {
            this.state.libraryPageText = libraryPageText_nl;
            this.state.prefix = '/nl';
        }
        if (this.state.language === "IT") {
            this.state.libraryPageText = libraryPageText_it;
            this.state.prefix = '/it';
        }
        if (this.state.language === "IT-CH") {
            this.state.libraryPageText = libraryPageText_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.state.language === "CZ") {
            this.state.libraryPageText = libraryPageText_cz;
            this.state.prefix = '/cz';
        }
        if (this.state.language === "FI") {
            this.state.libraryPageText = libraryPageText_fi;
            this.state.prefix = '/fi';
        }
        if (this.state.language === "PL") {
            this.state.libraryPageText = libraryPageText_pl;
            this.state.prefix = '/pl';
        }
        if (this.state.language === "SE") {
            this.state.libraryPageText = libraryPageText_se;
            this.state.prefix = '/se';
        }
        if (this.state.language === "NO") {
            this.state.libraryPageText = libraryPageText_no;
            this.state.prefix = '/nb';
        }
        if (this.state.language === "DK") {
            this.state.libraryPageText = libraryPageText_dk;
            this.state.prefix = '/dk';
        }
        if (this.state.language === "ES") {
            this.state.libraryPageText = libraryPageText_es;
            this.state.prefix = '/es';
        }
        if (this.state.language === "PT") {
            this.state.libraryPageText = libraryPageText_pt;
            this.state.prefix = '/pt';
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_en,
                    prefix: '',
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_de,
                    prefix: '/de',
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_de_ch,
                    prefix: '/de-ch',
                });
            }
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_en_ca,
                    prefix: '/en-ca',
                });
            }
            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_fr,
                    prefix: '/fr-ch',
                });
            }
            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_fr_ca,
                    prefix: '/fr-ca',
                });
            }
            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_fr_fr,
                    prefix: '/fr',
                });
            }
            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_nl,
                    prefix: '/nl',
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_it,
                    prefix: '/it',
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_it_ch,
                    prefix: '/it-ch',
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_cz,
                    prefix: '/cz',
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_fi,
                    prefix: '/fi',
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_pl,
                    prefix: '/pl',
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_se,
                    prefix: '/se',
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_no,
                    prefix: '/nb',
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_dk,
                    prefix: '/dk',
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_es,
                    prefix: '/es',
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    libraryPageText: libraryPageText_pt,
                    prefix: '/pt',
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.startAutoPlay();
    }

    componentWillUnmount() {
        this.clearAutoPlay();
        document.body.style.overflow = '';
    }

    startAutoPlay() {
        this.clearAutoPlay();
        this.autoPlayTimer = setInterval(() => {
            this.setState(prevState => {
                const nextStep = prevState.activeStep >= 6 ? 1 : prevState.activeStep + 1;
                return {
                    activeStep: nextStep,
                    imageLoaded: false,
                    progressKey: prevState.progressKey + 1,
                };
            }, () => {
                const img = new Image();
                img.onload = () => this.setState({ imageLoaded: true });
                img.onerror = () => this.setState({ imageLoaded: true });
                img.src = getLibertyStepImagePath(this.state.language, this.state.activeStep);
            });
        }, this.stepInterval);
    }

    clearAutoPlay() {
        if (this.autoPlayTimer) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
        }
    }

    handleStepClick(stepNumber) {
        this.clearAutoPlay();
        this.setState({ 
            activeStep: stepNumber,
            imageLoaded: false,
            progressKey: this.state.progressKey + 1,
        }, () => {
            const img = new Image();
            img.onload = () => this.setState({ imageLoaded: true });
            img.onerror = () => this.setState({ imageLoaded: true });
            img.src = getLibertyStepImagePath(this.state.language, stepNumber);
            this.startAutoPlay();
        });
    }

    getYouTubeVideoId = (url) => {
        if (!url) return '';
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|shorts\/))([A-Za-z0-9_-]{11})/);
        return match ? match[1] : '';
    };

    getYouTubeThumbnail = (url, highRes = false) => {
        const id = this.getYouTubeVideoId(url);
        if (!id) return '';
        return highRes
            ? `https://img.youtube.com/vi/${id}/maxresdefault.jpg`
            : `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    };

    handleFeaturedThumbError = (e, url) => {
        // Fall back if maxresdefault is unavailable for this video
        const fallback = this.getYouTubeThumbnail(url, false);
        if (e.target && fallback && e.target.src !== fallback) {
            e.target.src = fallback;
        }
    };

    buildLibertyEmbedUrl = (url) => {
        const id = this.getYouTubeVideoId(url);
        if (!id) return '';
        const params = new URLSearchParams({
            autoplay: '1',
            rel: '0',
            modestbranding: '1',
            enablejsapi: '1',
        });
        const ccLang = LIBERTY_CC_LANG[this.state.language];
        if (ccLang) {
            params.set('cc_load_policy', '1');
            params.set('cc_lang_pref', ccLang);
        }
        return `https://www.youtube.com/embed/${id}?${params.toString()}`;
    };

    openVideo = (video) => {
        if (!video || !video.youtubeUrl || !this.getYouTubeVideoId(video.youtubeUrl)) {
            return;
        }
        this.setState({ isVideoOpen: true, selectedVideo: video });
        document.body.style.overflow = 'hidden';
    };

    closeVideo = () => {
        this.setState({ isVideoOpen: false, selectedVideo: null });
        document.body.style.overflow = '';
    };

    render() {
        const { libraryPageText, isVideoOpen, selectedVideo } = this.state;
        const featuredVideo = libraryPageText.usingLibertyFeaturedVideo || null;
        const moreVideos = libraryPageText.usingLibertyMoreVideos || [];
        const showFactsheet = libraryPageText.factsheetUrl && libraryPageText.factsheetUrl !== '#';

        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.libraryPageText.title)}</title>
                    <meta name="title" content={parse(this.state.libraryPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.libraryPageText.descriptionMeta)}/>
                    <meta property="og:locale" content={this.state.libraryPageText.localeMeta}/>
                    <meta name="keywords" content={this.state.libraryPageText.keywords}/>
                </Helmet>
                <Header props={this.props}/>
                <section className="liberty-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-banner-content">
                                <h1 className="liberty-banner-title">{parse(this.state.libraryPageText.bannerTitle)}</h1>
                                <h2 className="liberty-banner-subtitle">{parse(this.state.libraryPageText.bannerSubtitle)}</h2>
                            </div>
                        </div>
                    </div>
                </section>
          
                <section className="liberty-intro">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-intro-content">
                                <div className="liberty-intro-text">
                                    <h2 className="liberty-intro-title">{parse(this.state.libraryPageText.introTitle)}</h2>
                                    <p className="liberty-intro-description">{parse(this.state.libraryPageText.introDescription)}</p>
                                    <div className="liberty-intro-compatibility">
                                        <img src={androidIcon} alt="Android" className="liberty-intro-icon" loading="lazy" decoding="async" />
                                        <img src={appleIcon} alt="Apple" className="liberty-intro-icon" loading="lazy" decoding="async" />
                                        <span className="liberty-intro-compatibility-text">{this.state.libraryPageText.bannerCompatibility}</span>
                                    </div>
                                </div>
                                <div className="liberty-intro-image">
                                    <img src="/images/hand-holding-phone-liberty.png" alt="Hand holding phone with CamAPS Liberty" decoding="async" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {['EN', 'CZ', 'DE', 'DE-CH', 'DK', 'ES', 'FI', 'FR', 'IT', 'IT-CH', 'NL', 'NO', 'PL', 'SE'].includes(this.state.language) && (
                <section className="liberty-announcement">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-announcement-content">
                                <p className="liberty-announcement-main">{parse(this.state.libraryPageText.announcementText)}</p>
                                {this.state.libraryPageText.announcementDisclaimer && (
                                    <p className="liberty-announcement-disclaimer">{parse(this.state.libraryPageText.announcementDisclaimer)}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                )}
                <section className="liberty-how-it-works">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-how-it-works-content">
                                <div className="liberty-how-it-works-header">
                                    <h2 className="liberty-how-it-works-title">{parse(this.state.libraryPageText.howItWorksTitle)}</h2>
                                    <p className="liberty-how-it-works-description">{parse(this.state.libraryPageText.howItWorksDescription)}</p>
                                </div>
                                <div className="liberty-steps-container">
                                    <div className="liberty-step-img phone-mockup-container liberty-phone-wrapper">
                                        <div className="liberty-phone-frame">
                                            <img 
                                                src="/images/liberty-phone-frame.svg" 
                                                alt="" 
                                                className="liberty-phone-frame-img"
                                                aria-hidden="true"
                                                loading="lazy"
                                                decoding="async"
                                            />
                                            <div className="liberty-phone-screen">
                                                <img 
                                                    src={getLibertyStepImagePath(this.state.language, this.state.activeStep)} 
                                                    alt={`Step ${this.state.activeStep} instruction`}
                                                    className="liberty-phone-screen-content"
                                                    loading="lazy"
                                                    decoding="async"
                                                    style={{ 
                                                        opacity: this.state.imageLoaded ? 1 : 0.7,
                                                        transition: 'opacity 0.3s ease-in-out'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = '/images/instruction-imagery-step1.png';
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="liberty-steps-list">
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 1 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(1)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step1Title)}</span>
                                                {this.state.activeStep === 1 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step1Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 1 && (
                                            <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                            </div>
                                        )}
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 2 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(2)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step2Title)}</span>
                                                {this.state.activeStep === 2 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step2Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 2 && (
                                            <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                            </div>
                                        )}
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 3 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(3)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step3Title)}</span>
                                                {this.state.activeStep === 3 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step3Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 3 && (
                                            <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                            </div>
                                        )}
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 4 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(4)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step4Title)}</span>
                                                {this.state.activeStep === 4 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step4Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 4 && (
                                            <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                            </div>
                                        )}
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 5 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(5)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step5Title)}</span>
                                                {this.state.activeStep === 5 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step5Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 5 && (
                                            <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                            </div>
                                        )}
                                        <div 
                                            className={`liberty-step-item ${this.state.activeStep === 6 ? 'active' : ''}`}
                                            onClick={() => this.handleStepClick(6)}
                                        >
                                            <div className="liberty-step-text">
                                                <span className="liberty-step-number">{parse(this.state.libraryPageText.step6Title)}</span>
                                                {this.state.activeStep === 6 && (
                                                    <span className="liberty-step-description">{parse(this.state.libraryPageText.step6Description)}</span>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.activeStep === 6 && (
                                            <>
                                                <div key={this.state.progressKey} className="liberty-step-progress-bar">
                                                    <div className="liberty-step-progress-bar-fill" style={{ animationDuration: `${this.stepInterval}ms` }} />
                                                </div>
                                                {this.state.libraryPageText.step6Footnote && (
                                                    <p className="liberty-step-footnote">{parse(this.state.libraryPageText.step6Footnote)}</p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="liberty-using-liberty">
                    <div className="container">
                        <div className="liberty-using-liberty-inner">
                            <div className="liberty-using-liberty-header">
                                <h2 className="liberty-using-liberty-title">{parse(libraryPageText.usingLibertyTitle)}</h2>
                                <p className="liberty-using-liberty-description">{parse(libraryPageText.usingLibertyDescription)}</p>
                            </div>

                            <div className="liberty-using-liberty-media">
                                {featuredVideo && (
                                    <div className="liberty-featured-video">
                                        <button
                                            type="button"
                                            className="liberty-featured-thumb"
                                            onClick={() => this.openVideo(featuredVideo)}
                                            aria-label={featuredVideo.title}
                                        >
                                            <img
                                                src={this.getYouTubeThumbnail(featuredVideo.youtubeUrl, true)}
                                                alt=""
                                                className="liberty-featured-thumb-img"
                                                loading="lazy"
                                                onError={(e) => this.handleFeaturedThumbError(e, featuredVideo.youtubeUrl)}
                                            />
                                            <img src={libertyPlayBtn} alt="" className="liberty-play-btn liberty-play-btn--large" />
                                        </button>
                                        <div className="liberty-featured-meta">
                                            <h3 className="liberty-featured-title">{parse(featuredVideo.title || '')}</h3>
                                            {(featuredVideo.duration || featuredVideo.date) && (
                                                <p className="liberty-featured-info">
                                                    {[featuredVideo.duration, featuredVideo.date].filter(Boolean).join(' | ')}
                                                </p>
                                            )}
                                            {featuredVideo.description && (
                                                <p className="liberty-featured-description">{parse(featuredVideo.description)}</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className="liberty-more-videos">
                                    <p className="liberty-video-label">{parse(libraryPageText.moreVideosLabel || 'More videos')}</p>
                                    <div className="liberty-more-videos-scroll">
                                        {moreVideos.map((video, index) => (
                                            <button
                                                type="button"
                                                key={`${video.youtubeUrl}-${index}`}
                                                className="liberty-more-video-card"
                                                onClick={() => this.openVideo(video)}
                                                aria-label={video.title}
                                            >
                                                <span className="liberty-more-thumb">
                                                    <img
                                                        src={this.getYouTubeThumbnail(video.youtubeUrl)}
                                                        alt=""
                                                        className="liberty-more-thumb-img"
                                                        loading="lazy"
                                                    />
                                                    <img src={libertyPlayBtn} alt="" className="liberty-play-btn liberty-play-btn--small" />
                                                    {video.duration && (
                                                        <span className="liberty-more-duration">{video.duration}</span>
                                                    )}
                                                </span>
                                                <span className="liberty-more-title">{parse(video.title || '')}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {showFactsheet && (
                                <a
                                    href={libraryPageText.factsheetUrl}
                                    className="liberty-factsheet-download"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={fileIcon} alt="" className="liberty-document-icon" />
                                    <span className="liberty-download-left">
                                        <img src={libertyDownloadArrow} alt="" className="liberty-download-arrow" />
                                        <span className="liberty-download-text">{parse(libraryPageText.factsheetDownloadText)}</span>
                                    </span>
                                </a>
                            )}
                        </div>
                    </div>
                </section>
                <section className="liberty-eligibility">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-eligibility-content">
                                <div className="liberty-eligibility-section">
                                    <h2 className="liberty-eligibility-title">{parse(this.state.libraryPageText.eligibilityTitle)}</h2>
                                    <div className="liberty-eligibility-criteria">
                                        <div className="liberty-criterion-item">
                                            <img src={greenCheckIcon} alt="Check" className="liberty-criterion-icon" loading="lazy" decoding="async" />
                                            <span className="liberty-criterion-text">{parse(this.state.libraryPageText.eligibilityCriterion1)}</span>
                                        </div>
                                        <div className="liberty-criterion-item">
                                            <img src={greenCheckIcon} alt="Check" className="liberty-criterion-icon" loading="lazy" decoding="async" />
                                            <span className="liberty-criterion-text">{parse(this.state.libraryPageText.eligibilityCriterion2)}</span>
                                        </div>
                                        <div className="liberty-criterion-item">
                                            <img src={redCloseIcon} alt="Not eligible" className="liberty-criterion-icon" loading="lazy" decoding="async" />
                                            <span className="liberty-criterion-text">{parse(this.state.libraryPageText.eligibilityCriterion3)}</span>
                                        </div>
                                    </div>
                                </div>
                             
                               
                            </div>
                        </div>
                    </div>
                </section>
                <section className="liberty-parents-carers">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-parents-carers-content">
                                <h2 className="liberty-parents-carers-title">{parse(this.state.libraryPageText.parentsCarersTitle)}</h2>
                                <div className="liberty-parents-carers-blocks">
                                    <div className="liberty-parents-carers-block">
                                        <img src={greenCheckIcon} alt="" className="liberty-parents-carers-icon" loading="lazy" decoding="async" />
                                        <div className="liberty-parents-carers-block-text">
                                            <strong>{parse(this.state.libraryPageText.parentsCarersBlockTitle)}</strong>
                                            <span>{parse(this.state.libraryPageText.parentsCarersBlockDescription)}</span>
                                        </div>
                                    </div>
                                    <div className="liberty-parents-carers-block">
                                        <img src={greenCheckIcon} alt="" className="liberty-parents-carers-icon" loading="lazy" decoding="async" />
                                        <div className="liberty-parents-carers-block-text">
                                            <strong>{parse(this.state.libraryPageText.parentsCarersRemoteTitle)}</strong>
                                            <span>{parse(this.state.libraryPageText.parentsCarersRemoteDescription)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="liberty-treatment-plan">
                    <div className="liberty-treatment-plan-hero">
                        <div className="liberty-treatment-plan-overlay">
                            <p className="liberty-treatment-plan-text">{parse(this.state.libraryPageText.treatmentPlanText)}</p>
                        </div>
                    </div>
                </section>
                {isVideoOpen && selectedVideo && (
                    <div className="video-modal-overlay" onClick={this.closeVideo}>
                        <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
                            <button type="button" onClick={this.closeVideo} className="video-modal-close" aria-label="Close">
                                <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L17 17M17 1L1 17" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <span>Close</span>
                            </button>
                            <div className="video-modal-video-wrapper">
                                <iframe
                                    className="video-modal-video"
                                    src={this.buildLibertyEmbedUrl(selectedVideo.youtubeUrl)}
                                    title={selectedVideo.title || 'CamAPS Liberty'}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    referrerPolicy="strict-origin-when-cross-origin"
                                />
                            </div>
                        </div>
                    </div>
                )}
                {/* <section className="liberty-what-happens-next">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 liberty-what-happens-next-content">
                                <h2 className="liberty-what-happens-next-title">{parse(this.state.libraryPageText.whatHappensNextTitle)}</h2>
                                <p className="liberty-what-happens-next-text">{parse(this.state.libraryPageText.whatHappensNextText)}</p>
                            </div>
                        </div>
                    </div>
                </section> */}
                <Footer props={this.props}/>
            </div>
        );
    }
}


